import { render } from "./ImprimirMatricula.vue?vue&type=template&id=e7708eac&scoped=true"
import script from "./ImprimirMatricula.vue?vue&type=script&lang=js"
export * from "./ImprimirMatricula.vue?vue&type=script&lang=js"

import "./ImprimirMatricula.vue?vue&type=style&index=0&id=e7708eac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7708eac"]])

export default __exports__